import { useEffect, useState } from 'react';
import { machinesApi } from '../../../lib/apis';
import { CreateMachineDto, Machine } from '../../../types/machines';

export function useUpdateMachine(id: string, onSuccess?: () => void) {
  const [form, setForm] = useState<CreateMachineDto>({ name: '', location: '', serialNumber: '', description: '', status: 'online' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await machinesApi.get<{ data: Machine }>(`/machines/${id}`);
      const m = res.data;
      setForm({
        name: m.name,
        location: m.location,
        serialNumber: m.serialNumber,
        description: m.description || '',
        status: m.status,
      });
    } catch (e: any) {
      setError(e.message || 'Failed to load');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const setField = <K extends keyof CreateMachineDto>(key: K, value: CreateMachineDto[K]) => {
    setForm(prev => ({ ...prev, [key]: value }));
  };

  const submit = async () => {
    setLoading(true);
    setError(null);
    try {
      await machinesApi.put<{ data: Machine }>(`/machines/${id}`, form);
      onSuccess?.();
    } catch (e: any) {
      setError(e.message || 'Failed to update');
    } finally {
      setLoading(false);
    }
  };

  return { form, setField, submit, loading, error };
}
